// extracted by mini-css-extract-plugin
export default {"container":"Movies_container__eqTXn","main_container":"Movies_main_container__xmzmA","title":"Movies_title__pWAl3","error":"Movies_error__HUjhn"};